/** @format */

import {
  BarChart,
  DonutSmall,
  Search,
  SwapVert,
  Visibility,
  AccountBox,
  FiberNew,
  Logout,
  Feedback,
  HelpCenter,
  Info,
  Settings,
  Home,
  AltRoute,
  AccountTree,
  AlignHorizontalCenter,
  Build,
  CurrencyRupee,
  ShoppingBag,
  Percent,
  Insights,
  EmojiObjects,
  TableChart,
  Radar,
  ViewModule,
  DonutLarge,
  Looks,
  ShowChart,
  Architecture,
  Science,
  TrendingUp,
  TrendingDown,
  Explore,
  Loyalty,
  Send,
  Sell,
  Speed,
  Celebration,
  AttachFile,
  Scale,
  Calculate,
  PointOfSale,
  InsertChart,
  AccountBalanceWallet,
} from '@mui/icons-material';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import AskAiIcon from '../Assets/SVG/AskAiIcon';
import dayjs from 'dayjs';

const userDetails = JSON.parse(localStorage.getItem('USER_DETAILS'));

export const FEW_PIVOT_AGGREGATORS = [
  'Sum',
  'Count',
  'Average',
  'Median',
  'Minimum',
  'Maximum',
];
export const FEW_PIVOT_RENDERERS = ['Table', 'Table Heatmap', 'Exportable TSV'];
const KPI_CARD_LIST = [
  { title: 'Sales', synonym: 'Amount', tooltip: 'Sales in lakhs' },
  { title: 'Quantity', synonym: 'Volume', tooltip: 'Quantity or Volume' },
  { title: 'ASP', synonym: 'ASP', tooltip: 'Average sale price' },
  { title: 'ABV', synonym: 'ABV', tooltip: 'Average bucket value' },
  { title: 'Margin', synonym: 'Margin', tooltip: 'Margin in %' },
];

export const USR_PROFILE_MENU = [
  { displayText: 'Profile', disabled: true, Icon: AccountBox },
  { displayText: `What's New`, disabled: true, Icon: FiberNew },
  { displayText: 'Feedback', disabled: true, Icon: Feedback },
  { displayText: 'Help', disabled: true, Icon: HelpCenter },
  { displayText: 'About', disabled: true, Icon: Info },
  {
    displayText: 'Settings',
    disabled: false,
    Icon: Settings,
    page: true,
    linkText: '/settings',
  },
  { displayText: 'Logout', disabled: false, Icon: Logout },
];

// pages menu
export const PAGES_MENU = [
  {
    id: 1,
    displayText: 'Flash',
    linkText: 'home',
    Icon: Home,
    enabled: true,
    toolbar: 'default',
  },
  // {
  //   id: 2,
  //   displayText: 'Drill Down',
  //   linkText: 'drill-down',
  //   Icon: AltRoute,
  //   enabled: true,
  //   toolbar: 'default',
  // },
  // {
  //   id: 3,
  //   displayText: 'Data Tree',
  //   linkText: 'data-tree',
  //   Icon: AccountTree,
  //   enabled: true,
  //   toolbar: 'default',
  // },
  // {
  //   id: 5,
  //   displayText: 'Ask SAM',
  //   linkText: 'ask-ai',
  //   enabled: true,
  //   // enabled: [98, 31].includes(userDetails?.client_id), // Only for specific clients
  //   Icon: AskAiIcon,
  //   toolbar: 'default',
  // },
  {
    id: 6,
    displayText: 'Revenue',
    linkText: 'biz-barometr',
    Icon: PointOfSale,
    enabled: true,
    toolbar: 'bizbarometr',
  },
  {
    id: 7,
    displayText: 'Opex',
    linkText: 'biz-expense',
    Icon: Calculate,
    enabled: true,
    toolbar: 'bizbarometr',
  },
  {
    id: 8,
    displayText: 'Profit',
    linkText: 'biz-profit',
    Icon: TrendingUp,
    enabled: true,
    toolbar: 'bizbarometr',
  },
  {
    id: 10,
    displayText: 'KPIs',
    linkText: 'biz-kpis',
    Icon: Insights,
    enabled: true,
    toolbar: 'bizbarometr',
  },
  {
    id: 11,
    displayText: 'Variance',
    linkText: 'variance-module',
    Icon: CompareArrowsIcon,
    enabled: true,
    toolbar: 'bizbarometr',
  },
  {
    id: 9,
    displayText: 'Forecast',
    linkText: 'forecast',
    Icon: InsertChart,
    enabled: true,
    toolbar: 'bizbarometr',
  },
  {
    id: 13,
    displayText: 'Budget Comparison',
    linkText: 'budget-comparison',
    Icon: AccountBalanceWallet,
    enabled: true,
    toolbar: 'bizbarometr',
  },
  {
    id: 12,
    displayText: 'Benchmark',
    linkText: 'benchmark',
    Icon: AccountTree,
    enabled: true,
    toolbar: 'default',
  },
];

const USER_PAGE_ACCESS = {
  'abhisekh@mani-group.com': [
    'home',
    'biz-barometr',
    'biz-expense',
    'biz-profit',
    'forecast',
    'biz-kpis',
    'variance-module',
  ],
  abhisekh: [
    'home',
    'biz-barometr',
    'biz-expense',
    'biz-profit',
    'forecast',
    'biz-kpis',
    'variance-module',
  ],
  'Aa@mani': [
    'home',
    'biz-barometr',
    'biz-expense',
    'biz-profit',
    'forecast',
    'biz-kpis',
    'variance-module',
  ],
  'sanjay@mani-group.com': ['home'],
  sanjay: ['home'],
  'Ceo@mani': ['home'],
};

export function getUserAccessPages() {
  try {
    const storedUser = JSON.parse(localStorage.getItem('USER_DETAILS') || '{}');
    const validValues = [
      storedUser?.email,
      storedUser?.username,
      storedUser?.preferred_username,
      storedUser?.client_name,
      storedUser?.user_name,
      storedUser?.name,
    ]
      .filter(Boolean)
      .map((value) => String(value).trim().toLowerCase());

    for (const candidate of validValues) {
      const accessPages =
        USER_PAGE_ACCESS[candidate] ||
        Object.entries(USER_PAGE_ACCESS).find(
          ([username]) => username.toLowerCase() === candidate
        )?.[1];

      if (accessPages) {
        return accessPages;
      }

      const shortName = candidate.split('@')[0];
      if (USER_PAGE_ACCESS[shortName]) {
        return USER_PAGE_ACCESS[shortName];
      }
    }

    return null;
  } catch (error) {
    return null;
  }
}

export function canAccessPage(pagePath) {
  const normalizedPath = String(pagePath || '')
    .replace(/^\/+/, '')
    .replace(/\/+$/, '');

  if (!normalizedPath) {
    return true;
  }

  const allowedPages = getUserAccessPages();

  if (!allowedPages) {
    return true;
  }

  return allowedPages.includes(normalizedPath);
}

export const CHART_NAMES = {
  BAR: 'BAR',
  COLUMN: 'COLUMN',
  PIE: 'PIE',
  DONUT: 'DONUT',
  HALFDONUT: 'HALFDONUT',
  GAUGE: 'GAUGE',
  TANGENTIAL_POLAR: 'TANGENTIAL_POLAR',
  LINE: 'LINE',
  MULTI_LINE: 'MULTI_LINE',
  TABLE: 'TABLE',
  RADAR: 'RADAR',
  TREEMAP: 'TREEMAP',
};

// Types of charts a user can convert to.
const CHART_TYPES = [
  {
    id: 1,
    type: CHART_NAMES.PIE,
    icon: <DonutSmall sx={{ color: 'gray' }} fontSize="small" />,
  },
  {
    id: 2,
    type: CHART_NAMES.COLUMN,
    icon: <BarChart sx={{ color: 'gray' }} fontSize="small" />,
  },
  {
    id: 3,
    type: CHART_NAMES.BAR,
    icon: <BarChart sx={{ rotate: '90deg', color: 'gray' }} fontSize="small" />,
  },
  {
    id: 4,
    type: CHART_NAMES.LINE,
    icon: <ShowChart sx={{ color: 'gray' }} fontSize="small" />,
  },
  {
    id: 5,
    type: CHART_NAMES.TABLE,
    icon: <TableChart sx={{ color: 'gray' }} fontSize="small" />,
  },
  {
    id: 6,
    type: CHART_NAMES.RADAR,
    icon: <Radar sx={{ color: 'gray' }} fontSize="small" />,
  },
  {
    id: 7,
    type: CHART_NAMES.HALFDONUT,
    icon: <Looks sx={{ color: 'gray' }} fontSize="small" />,
  },
  {
    id: 8,
    type: CHART_NAMES.TREEMAP,
    icon: <ViewModule sx={{ color: 'gray' }} fontSize="small" />,
  },
  {
    id: 9,
    type: CHART_NAMES.DONUT,
    icon: (
      <DonutLarge
        sx={{ color: 'gray', transform: 'rotate(360deg)' }}
        fontSize="small"
      />
    ),
  },
];

const DATA_TREE_GRAPHS = {
  TABLE: 'TABLE',
  PIVOT: 'PIVOT',
  TREE: 'TREE',
  MATRIX: 'MATRIX',
};

export const INLINE_PAGES = {
  STACKED: 'stacked',
  DUAL_LINE: 'dualline',
  VARIANCE_CARD: 'variance',
};

export const THEMES = {
  DARK: 'DARK',
  LIGHT: 'LIGHT',
};

export const DTREE_UTIL_BTNS = {
  SEARCH: 'SEARCH',
  VIEW: 'VIEW',
  SORT: 'SORT',
};

export const DTREE_COL_ITEM_VAL_KEYS = {
  SALES: 'Sales',
  VOLUME: 'Volume',
  MARGIN: 'Margin',
  ASP: 'ASP',
};
export const DTREE_COL_ITEM_VALS = [
  DTREE_COL_ITEM_VAL_KEYS.SALES,
  DTREE_COL_ITEM_VAL_KEYS.VOLUME,
  DTREE_COL_ITEM_VAL_KEYS.MARGIN,
  DTREE_COL_ITEM_VAL_KEYS.ASP,
];

export const DTREE_UTIL_LIS = [
  {
    key: DTREE_UTIL_BTNS.SEARCH,
    name: 'Search',
    Icon: Search,
  },
  {
    key: DTREE_UTIL_BTNS.VIEW,
    name: 'View',
    Icon: Visibility,
  },
  {
    key: DTREE_UTIL_BTNS.SORT,
    name: 'Sort by Sales',
    Icon: SwapVert,
  },
];

const HIDE_TABLE_VIEW = ['sales_by_month'];

const TREE_OPTION_BTNS = [
  {
    id: 1,
    name: 'TABLE',
    key: DATA_TREE_GRAPHS.TABLE,
  },
  // {
  //   id: 2,
  //   name: 'Sankey',
  // },
  {
    id: 3,
    name: 'Tree',
    key: DATA_TREE_GRAPHS.TREE,
  },
];

const TREE_FIRST_NODE = { TOTAL_SALES: 'Total Sales' };

export const SYMBOLS = {
  CURRENCY: {
    RUPEES: '&#8377;',
  },
  DERIVED: { PERCENTAGE: '&#65285;' },
  MATERIAL: { LITRE: '' },
};

export const VECTOR_ICONS = {
  CurrencyRupee,
  ShoppingBag,
  Science,
  Architecture,
  Explore,
  EmojiObjects,
  Loyalty,
  Send,
  Sell,
  Speed,
  Celebration,
  AttachFile,
  Build,
  Scale,
  Percent,
  DEFAULT: EmojiObjects,
};

const FRAMES = [
  {
    title: '1D',
    from: dayjs(),
    to: dayjs().startOf('day'),
  },
  {
    title: '1W',
    from: dayjs(),
    to: dayjs().subtract(1, 'week').startOf('day'),
  },
  {
    title: '1M',
    from: dayjs(),
    to: dayjs().subtract(1, 'month').startOf('day'),
  },
  {
    title: '3M',
    from: dayjs(),
    to: dayjs().subtract(3, 'month').startOf('day'),
  },
  {
    title: '1Y',
    from: dayjs(),
    to: dayjs().subtract(1, 'year').startOf('day'),
  },
];

export const ACCESS_ROLES = {
  NAVAAN_ADMIN: 'Navaan_Admin',
  NAVAAN_SUPPORT: 'Navaan_Support',
  NAVAAN_USER: 'Navaan_User',
  ACCOUNT_ADMIN: 'Account_Admin',
  ACCOUNT_USER: 'Account_User',
  CLIENT_ADMIN: 'Client_Admin',
  CLIENT_USER: 'Client_User',
};
export const ROOT_USERNAME = 'navaanadmin';
// production environment
export const REALM_NAME = 'navaantrix';
export const CLIENT_ID = 'vyakhyan';
export const CLIENT_NAME = 'vyakhyan';

// staging environment
// export const REALM_NAME = 'navaantrix-stage'; 
// export const CLIENT_ID = 'vyakhyan-stage';
// export const CLIENT_NAME = 'vyakhyan-stage';

export const USER_ROLE_LEVELS = {
  [ACCESS_ROLES.NAVAAN_ADMIN]: 0,
  [ACCESS_ROLES.NAVAAN_SUPPORT]: 1,
  [ACCESS_ROLES.NAVAAN_USER]: 2,
  [ACCESS_ROLES.ACCOUNT_ADMIN]: 3,
  [ACCESS_ROLES.ACCOUNT_USER]: 4,
  [ACCESS_ROLES.CLIENT_ADMIN]: 5,
  [ACCESS_ROLES.CLIENT_USER]: 6,
};

export {
  KPI_CARD_LIST,
  CHART_TYPES,
  TREE_OPTION_BTNS,
  FRAMES,
  DATA_TREE_GRAPHS,
  TREE_FIRST_NODE,
  HIDE_TABLE_VIEW,
};
